/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { LightListDetailPopupWrap } from '@styles/base.style'
import { isMobile } from 'react-device-detect'
import { NOTICE_CATEGORY } from '@v2/constants/common'
import dayjs from 'dayjs'

const NoticeDetail: React.FC = () => {
  const { componentStore } = useRootStore()
  const { noticeDetail = { category: '', title: '', content: '', createdAt: '', thumbnailUrl: null } } = componentStore
  const { category, title, content, createdAt, thumbnailUrl } = noticeDetail
  let thumbnail

  if (category !== NOTICE_CATEGORY.TIP
  && thumbnailUrl) {
    thumbnail = (
      <div className="list-contents">
        <img className="thumbnail" src={thumbnailUrl} alt="첨부 이미지"/>
      </div>
    )
  }

  const contentHTML = content.replace(/<br\b[^>]*\/?>/gi, '') // 10603 - shift+Enter 시 br로 한 줄 추가되는 이슈 방지

  return (
    <LightListDetailPopupWrap className={!isMobile && 'pc'}>
      <Fragment>
        <div className="list-info">
          <p className="tit line-2">{title}</p>
          <p className="date">{dayjs(createdAt).format('YYYY.MM.DD')}</p>
        </div>
        <div className="list-contents" dangerouslySetInnerHTML={{ __html: contentHTML }}/>
        {thumbnail}
      </Fragment>
    </LightListDetailPopupWrap>
  )
}
export default observer(NoticeDetail)
